import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function JournalItem({ factors, getText, title, backgroundColor }) {
  const { t } = useTranslation();
  const [showFactors, setShowFactors] = useState(false);

  return (
    <div className="fs-mask">
      <button type="button" className="journal-button" onClick={() => setShowFactors(!showFactors)}>
        {`${showFactors ? t('journal.entry.hide') : t('journal.entry.show')} ${title}`}
      </button>
      <div className="line fs-mask" style={{ backgroundColor: `${backgroundColor}` }}>
        {showFactors && (
          <div className="journal-tooltip">
            <p>{title}</p>
            {factors.map((item, index) => {
              return <div key={index}>{t(getText(item))}</div>;
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default JournalItem;
